<template>
  <div>
    <component :is="dialogConfig.name" :dialogConfig="dialogConfig" @cancleDialog="cancleDialog(arguments)"></component>
    <Header />
    <div class="main">
      <div class="c">
        <div class="title">
          <div class="return" @click="back()">
            <a-icon type="left" />
            <span>返回</span>
          </div>
          <span class="assessName">{{this.assessName}}</span>
        </div>
        <div class="paper">
          <div class="paper-left">
            <!-- <div class="scoreTable">
              <table>
                <tr>
                  <td></td>
                  <td>
                    <span class="queType">单选题</span>
                    <span class="queNum">(共{{this.radio_num}}题)</span>
                  </td>
                  <td>
                    <span class="queType">多选题</span>
                    <span class="queNum">(共{{this.check_num}}题)</span>
                  </td>
                  <td>
                    <span class="queType">判断题</span>
                    <span class="queNum">(共{{this.judge_num}}题)</span>
                  </td>
                  <td>
                    <span class="queType">问答题</span>
                    <span class="queNum">(共{{this.answer_num}}题)</span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <span>正确 (题)</span>
                  </td>
                  <td>
                    <span>{{this.sure_rdio}}</span>
                  </td>
                  <td>
                    <span>{{this.sure_check}}</span>
                  </td>
                  <td>
                    <span>{{this.sure_judge}}</span>
                  </td>
                  <td>
                    <span v-if="showWait">?</span>
                    <span v-else>{{this.sure_answer}}</span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <span>错误 (题)</span>
                  </td>
                  <td>
                    <span>{{this.error_rdio}}</span>
                  </td>
                  <td>
                    <span>{{this.error_check}}</span>
                  </td>
                  <td>
                    <span>{{this.error_judge}}</span>
                  </td>
                  <td>
                    <span v-if="showWait">?</span>
                    <span v-else>{{this.error_answer}}</span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <span>未答 (题)</span>
                  </td>
                  <td>
                    <span>{{this.not_rdio}}</span>
                  </td>
                  <td>
                    <span>{{this.not_check}}</span>
                  </td>
                  <td>
                    <span>{{this.not_judge}}</span>
                  </td>
                  <td>
                    <span>{{this.not_answer}}</span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <span class="bold">得分 </span>(分)
                  </td>
                  <td>
                    <span class="scoreTotal">{{this.radio_score}}</span>
                  </td>
                  <td>
                    <span class="scoreTotal">{{this.check_score}}</span>
                  </td>
                  <td>
                    <span class="scoreTotal">{{this.judge_score}}</span>
                  </td>
                  <td>
                    <span>{{this.answer_score}}</span>
                  </td>
                </tr>
              </table>
              <div class="score">
                <p class="total1">总分</p>
                <p class="total2">{{this.full_score}}</p>
                <p class="myScore1" v-if="showWait">我的分数</p>
                <p class="myScore1" v-else-if="isQualified">合格</p>
                <p class="myScore1" v-else>不合格</p>
                <p class="myScore2">
                  <span class="sait" v-if="showWait">待评</span>
                  <span class="myScore" v-else>{{user_score}}</span>
                </p>
              </div>
            </div> -->
            <div class="scoreLines">
              <div v-if="subjective_count > 0" class="score-left">{{is_subjective == 1 ? '主观题学员自评分' : '主观题教师评分'}}</div>
              <div class="score-right">
                <div class="now-nums">{{user_score}}分</div>
                <div class="two-group">
                  <!-- <div v-if="subjective_count > 0 && questions[currentIndex] && questions[currentIndex].is_score && questions[currentIndex].is_score == 2" class="status">待评分</div> -->
                  <div v-if="subjective_count > 0 && is_assess == 2" class="status">待评分</div>
                  <div class="all-num">（满分{{full_score}}分）</div>
                </div>
              </div>
            </div>
            <component :is="tebActive" :questionData="questionData" :key="questionData.index" @submited="submited"></component>
          </div>
          <div class="paper-right">
            <p class="time">用时：{{this.duration}}</p>
            <div class="paper-right-title">答题卡</div>
            <div class="paper-right-selects">
              <ul>
                <li v-for="(item,index) in questions" :key="item.que_id" ref="li" :style="{background:index==currentIndex?'#2462F5':item.answerState,color:index==currentIndex?'#fff':item.answerColor}" @click="toQuestion(item,index)">
                  {{item.num}}
                  <img v-show="item.is_sign == '1'" src="../../../assets/sign.png" alt="">
                </li>
              </ul>
            </div>
            <div class="tip">
              <span>正确</span>
              <div class="answered"></div>
              <span>错误</span>
              <div class="error"></div>
              <span>待评</span>
              <div class="noEvaluate"></div>
              <span>未答</span>
              <div class="noAnswer"></div>
            </div>
            <div class="submit" @click="again()" v-if="can_answer == 1">
              再次作答
            </div>
          </div>
        </div>
        <div class="button-box" v-if="this.questions.length>1">
          <div class="buPrevious" ref="buPrevious" @click="previous()">上一题</div>
          <div class="buNext" ref="buNext" @click="next()">下一题</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Footer from '../../../components/Footer'
import Header from '../../../components/Header'
import radio from './AgainPractice/radio'
import checkbox from './AgainPractice/checkbox'
import fillBlanks from './AgainPractice/fillBlanks'
import assCombination from './AgainPractice/assCombination'
import assQueAnswer from './AgainPractice/assQueAnswer'
import judge from './AgainPractice/judge'
import services from '../../../config/services'
import { Message } from "ant-design-vue";
import { mapActions, mapState } from "vuex";
export default {
  name: "againAssess",
  components: {
    Footer, Header, radio, checkbox, fillBlanks, assQueAnswer, judge, assCombination,
    assessInfo: () => import("./assessInfo.vue")
  },
  data () {
    return {
      tebActive: "",
      questionData: "",
      questions: "",
      ass_id: this.$route.query.ass_id,
      assessName: this.$route.query.assessName,
      record_id: this.$route.query.record_id,
      class_id: this.$route.query.class_id,
      duration: this.$route.query.duration, // 答题用时
      is_assess: this.$route.query.is_assess, // 是否评阅1是2否
      currentIndex: 0,//当前位置
      dialogConfig: {
        name: '',
        title: '',
        data: null,
        dialogVisible: true,
      },
      is_subjective: '', // 主观自评1是2否
      full_score: 0,//总分数
      user_score: 0,//用户分数
      can_answer:  2, //1可以再次作答2不可以
      subjective_count: 0, // 大于0有主观题 0 没有
    }
  },
  computed: {
    ...mapState({
      loginUserInfo: (state) => state.appsLogin.appsUserInfo,
    })
  },
  created () {
    let that = this;
    services.assessResultCard({
      record_id: this.record_id
    }).then((res) => {
      if(res.code == '0000'){
        this.full_score = res.data.total_score
        this.user_score = res.data.total_user_score
        this.can_answer = res.data.can_answer
        this.is_subjective = res.data.is_subjective
        this.is_assess = res.data.is_assess
        this.duration = res.data.duration
        this.subjective_count = res.data.subjective_count
        this.questions = res.data.items;
        this.questions.forEach(function (item) {
          that.colorFunc(item);
        });
        services.questionGetbyassess({
          que_id: this.questions[0].que_id,
          exam_id: this.ass_id,
          record_id: this.record_id,
          class_id: this.class_id,
          is_again: 2,
        }).then((second) => {
          //this.questions[0] = res.data;
          // if (second.code == "0000") {
            this.questions[0] = Object.assign(this.questions[0], second.data);
          // }
          if (this.questions[0].type == "1") {
            this.tebActive = "radio";
          }
          if (this.questions[0].type == "2") {
            this.tebActive = "checkbox";
          }
          if (this.questions[0].type == "3") {
            this.tebActive = "judge";
          }
          if (this.questions[0].type == "4") {
            this.tebActive = "assQueAnswer";
          }
          if (this.questions[0].type == "5") {
            this.tebActive = "assCombination";
          }
          this.questionData = {
            data: this.questions[0],
            index: this.currentIndex,
            record_id: this.record_id,
            ass_id: this.ass_id,
            is_subjective: this.is_subjective
          }
        });
      } else {
        that.$message.warning(res.message ? res.message : "获取答题卡失败");
      }
    });
  },
  watch: {
    currentIndex: function (val) {
      if (val == this.questions.length - 1) {
        this.$refs.buNext.style.background = "#ECEAEA";
        this.$refs.buNext.style.color = "#999999";
        this.$refs.buPrevious.style.background = "#DBE6FD";
        this.$refs.buPrevious.style.color = "#999999";
        this.$refs.buNext.style.cursor = "not-allowed";
        this.$refs.buPrevious.style.cursor = "pointer";
      }
      if (val == 0) {
        this.$refs.buPrevious.style.background = "#ECEAEA";
        this.$refs.buPrevious.style.color = "#999999";
        this.$refs.buNext.style.background = "#2462F5";
        this.$refs.buNext.style.color = "#FFFFFF";
        this.$refs.buPrevious.style.cursor = "not-allowed";
        this.$refs.buNext.style.cursor = "pointer";
      }
      if (val > 0 && val < this.questions.length - 1) {
        this.$refs.buPrevious.style.background = "#DBE6FD";
        this.$refs.buPrevious.style.color = "#999999";
        this.$refs.buNext.style.background = "#2462F5";
        this.$refs.buNext.style.color = "#FFFFFF";
        this.$refs.buPrevious.style.cursor = "pointer";
        this.$refs.buNext.style.cursor = "pointer";
      }
    }
  },
  methods: {
    // 返回
    back () {
      this.$router.push({
        path:  `/${this.loginUserInfo && this.loginUserInfo.school_code}/user/myAssess`,
        query: {
          tabs: 1,
        }
      });
    },
    //跳转到该题
    toQuestion (val, index) {
      this.currentIndex = index;
      services.questionGetbyassess({
        que_id: val.que_id,
        exam_id: this.ass_id,
        record_id: this.record_id,
        is_again: 2,
        class_id: this.class_id
      }).then((res) => {
        //delete this.questions[index].que_id;
        // if(res.code == '0000'){
          this.questions[index] = Object.assign(this.questions[index], res.data);
          let obj =  {
            data: this.questions[index],
            index: index,
            record_id: this.record_id,
            is_subjective: this.is_subjective
          };
          if (this.questions[index].type == "1") {
            this.tebActive = 'radio';
          } else if (this.questions[index].type == "2") {
            this.tebActive = 'checkbox';
          } else if (this.questions[index].type == "5") {
            // this.tebActive = 'fillBlanks';
            this.tebActive = 'assCombination';
            obj.ass_id = this.ass_id
          } else if (this.questions[index].type == "4") {
            this.tebActive = 'assQueAnswer';
            obj.ass_id = this.ass_id
          } else if (this.questions[index].type == "3") {
            this.tebActive = 'judge';
          }
          this.questionData = obj
        // }
      });
    },
    //跳转下一题
    next () {
      if (this.currentIndex < this.questions.length - 1) {
        this.$refs.li[this.currentIndex + 1].click();
      }
      if (this.currentIndex == this.questions.length - 1) {
        this.$refs.buNext.style.background = "#ECEAEA";
        this.$refs.buNext.style.color = "#999999";
      } else {
        this.$refs.buNext.style.background = "#2462F5";
        this.$refs.buNext.style.color = "#FFFFFF";
        this.$refs.buPrevious.style.background = "#DBE6FD";
        this.$refs.buPrevious.style.color = "#999999";
      }
    },
    //跳转上一题
    previous () {
      if (this.currentIndex > 0) {
        this.$refs.li[this.currentIndex - 1].click();
      }
      if (this.currentIndex == 0) {
        this.$refs.buPrevious.style.background = "#ECEAEA";
        this.$refs.buPrevious.style.color = "#999999";
      } else {
        this.$refs.buPrevious.style.background = "#DBE6FD";
        this.$refs.buPrevious.style.color = "#999999";
        this.$refs.buNext.style.background = "#2462F5";
        this.$refs.buNext.style.color = "#FFFFFF";
      }
    },
    //再次作答
    again () {
      this.assessGetDetail(this.ass_id);
      this.dialogConfig.name = 'assessInfo';
      this.dialogConfig.title = "提示";
    },
    //过滤
    colorFunc (item) {
      if (item.is_right != 0) {
        if (item.is_right == "1") {
          this.$set(item, "answerState", "#D7F3EA");
          this.$set(item, "answerColor", "#32B387");
        } else {
          this.$set(item, "answerState", "#FAE7E6");
          this.$set(item, "answerColor", "#EC8D8B");
        }
        if (item.is_score == "2") {
          this.$set(item, "answerState", "#F7EDCF");
          this.$set(item, "answerColor", "#D59A20");
        } 
      } else {
        this.$set(item, "answerState", "#ffffff");
        this.$set(item, "answerColor", "#666666");
      }
    },
    //测评详情
    assessGetDetail (ass_id) {
      services.assessGet({
        id: ass_id,
        data: {
          class_id: this.class_id
        }
      }).then((res) => {
        if (res.code == "0000") {
          this.assessData = res.data;
          this.dialogConfig.data = this.assessData;
        } else {
          Message.error(res.message);
        }
      })
    },
    //打分完成再次获取答题卡
    submited (data) {
      // for (let i = 0; i < data.items.length; i++) {
      //   this.questions[i].is_right = data.items[i].is_right;
      //   this.colorFunc(this.questions[i]);
      // }
      let that = this
      services.assessResultCard({
        record_id: this.record_id
      }).then((res) => {
        if(res.code == '0000'){
          this.full_score = res.data.total_score
          this.user_score = res.data.total_user_score
          this.can_answer = res.data.can_answer
          this.is_subjective = res.data.is_subjective
          this.is_assess = res.data.is_assess
          this.duration = res.data.duration
     
          this.questions = res.data.items;
          this.questions.forEach(function (item) {
            that.colorFunc(item);
          });
          services.questionGetbyassess({
            que_id: data.que_id,
            exam_id: data.ass_id,
            record_id: data.record_id,
            class_id: this.class_id,
            is_again: 2,
          }).then((second) => {
            if(second.code == '0000'){
              this.questions[that.currentIndex] = Object.assign(this.questions[that.currentIndex], second.data);
              let obj =  {
                data: this.questions[that.currentIndex],
                index: that.currentIndex,
                record_id: this.record_id,
                is_subjective: this.is_subjective
              };
              if (this.questions[that.currentIndex].type == "1") {
                this.tebActive = 'radio';
              } else if (this.questions[that.currentIndex].type == "2") {
                this.tebActive = 'checkbox';
              } else if (this.questions[that.currentIndex].type == "5") {
                // this.tebActive = 'fillBlanks';
                this.tebActive = 'assCombination';
                obj.ass_id = this.ass_id
              } else if (this.questions[that.currentIndex].type == "4") {
                this.tebActive = 'assQueAnswer';
                obj.ass_id = this.ass_id
              } else if (this.questions[that.currentIndex].type == "3") {
                this.tebActive = 'judge';
              }
              this.questionData = obj
            }
          });
        }
      })
    },
  }
};
</script>

<style lang="less" scoped>
.c {
  padding-top: 10px;
}
.return {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #2462f5;
  line-height: 32px;
  cursor: pointer;
  float: left;
  margin-top: 3px;
}
.main {
  background: #f6f6f6;
}
.UserNav {
  box-shadow: 0px 0px 21px 0px rgba(25, 52, 116, 0.15);
}
.title {
  height: 40px;
  background: #fff;
  border-top: 3px solid #90b1ff;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  text-align: center;
}
.title .assessName {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333333;
  line-height: 40px;
}
.paper {
  margin-top: 20px;
  position: relative;
  padding-bottom: 80px;
}
.paper-left {
  width: calc(100% - 330px);
  height: auto;
  min-height: 530px;
  background: #ffffff;
  margin-right: 20px;
  float: left;
  margin-bottom: 10px;
}
.paper-right {
  width: 310px;
  /* max-height: 566px; */
  background: #ffffff;
  float: left;
  padding-bottom: 20px;
}
.paper-right-title {
  width: 56px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #14202c;
  line-height: 32px;
  margin-top: 10px;
  margin-left: 30px;
}
.paper:after {
  content: '';
  display: block;
  clear: both; /* height: 0;overflow: hidden; 为了解决 IE 浏览器的兼容问题 */
  height: 0;
  overflow: hidden; /* visibility:hidden;为了去隐藏content中的内容 */
  visibility: hidden;
}
.button-box {
  padding-top: 30px;
  box-sizing: border-box;
  margin-top: 10px;
  height: 80px;
  background: #fff;
  position: fixed;
  bottom: 0;
  width: 870px;
  z-index: 99;
}
.button-box div {
  width: 100px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  border-radius: 22px;
  margin: 0 166px;
  display: inline-block;
  vertical-align: top;
}
.button-box:after {
  content: ' ';
  clear: both;
  display: block;
  height: 0;
  visibility: hidden;
}
.buPrevious {
  background: rgb(236, 234, 234);
  color: rgb(153, 153, 153);
  cursor: not-allowed;
}
.buPrevious:hover {
  background: #bbcdf3 !important;
  color: #ffffff !important;
}
.buNext {
  background: #2462f5;
  color: #fff;
  cursor: pointer;
}
.buNext:hover {
  background: #134bce !important;
  color: #ffffff !important;
}
ul {
  display: flex;
  flex-wrap: wrap;
  margin-left: 30px;
}
li {
  min-width: 32px;
  padding: 0 0;
  height: 32px;
  line-height: 32px;
  text-align: center;
  float: left;
  font-size: 12px;
  margin-right: 20px;
  margin-top: 15px;
  border: 1px solid #e4e4e4;
  cursor: pointer;
  position: relative;
}
li:hover {
  background: #dbe6fd !important;
  color: #999999 !important;
}
li img {
  height: 14px;
  width: 14px;
  position: absolute;
  top: -7px;
  right: -7px;
}
.tip {
  height: 32px;
  display: flex;
  align-items: center;
  margin-left: 20px;
  margin-top: 30px;
  margin-bottom: 30px;
}
.tip span {
  width: 29px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
  line-height: 32px;
  margin-right: 8px;
}
.answered {
  width: 16px;
  height: 16px;
  background: #d7f3ea;
  float: left;
  margin-right: 20px;
}
.noAnswer {
  width: 16px;
  height: 16px;
  background: #ffffff;
  border: 1px solid #e4e4e4;
  float: left;
}
.noEvaluate {
  width: 16px;
  height: 16px;
  background: #f7edcf;
  float: left;
  margin-right: 20px;
}
.submit {
  color: #fff;
  width: 220px;
  height: 30px;
  background: #2462f5;
  border-radius: 22px;
  line-height: 30px;
  text-align: center;
  margin-left: 45px;
  cursor: pointer;
}
.submit:hover {
  background: #134bce !important;
  color: #ffffff !important;
}
.error {
  background: #fae7e6;
  width: 16px;
  height: 16px;
  float: left;
  margin-right: 20px;
}
.paper-right-selects {
  overflow-y: auto;
}
::-webkit-scrollbar-thumb {
  background-color: #dddddd;
  background-clip: padding-box;
  min-height: 28px;
}
.time {
  margin: 20px auto;
  text-align: center;
  color: #e18c31;
  font-size: 16px;
}
.queType {
  font-size: 14px;
  font-weight: bold;
  color: #333;
}
.queNum {
  font-size: 12px;
  color: #868587;
}
.scoreTable {
  padding: 20px 50px 0px 50px;
  overflow: hidden;
}
.bold {
  font-weight: bold;
}
.scoreTotal {
  color: #9a3bec;
}
table {
  width: 85%;
  float: left;
  border-bottom: 1px solid #dedede;
}
tr {
  height: 40px;
}
tr:first-child {
  background: #dbe6fd;
}
td {
  text-align: center;
}
.score {
  background: url('../../../assets/score.png');
  width: 80px;
  float: right;
  height: 144px;
}
.total1 {
  font-size: 14px;
  color: #8446ab;
  text-align: center;
  margin-top: 10px;
}
.total2 {
  font-size: 18px;
  color: #9a3bec;
  text-align: center;
  border-bottom: 9px solid #fff;
  padding-bottom: 5px;
}
.myScore1 {
  color: #8446ab;
  font-size: 14px;
  text-align: center;
  margin-top: 10px;
}
.myScore2 {
  text-align: center;
  margin-top: 5px;
}
.myScore2 .sait {
  font-size: 18px;
  color: #d59a20;
  text-align: center;
  margin-top: 5px;
}
.myScore2 .myScore {
  font-size: 18px;
  color: #9a3bec;
  text-align: center;
  margin-top: 5px;
}
.scoreLines {
  height: 40px;
  padding: 0 50px;
  background: linear-gradient(90deg, #FEF7ED 0%, #FFFFFF 100%);
  .score-left {
    float: left;
    line-height: 40px;
    font-size: 14px;
    font-weight: bold;
    color: #FD9A08;
  }
  .score-right {
    float:  right;
    display: flex;
    height: 40px;
    align-items: center;
    .now-nums {
      flex: 1;
      font-size: 18px;
      font-weight: bold;
      color: #FD9A08;
      display: inline-block;
      margin-right: 4px;
    }
    .two-group {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .all-num {
        font-size: 10px;
        color: #9FA4AA;
        line-height: 12px;
      }
      .status {
        width: 56px;
        height: 16px;
        background: #FD9A08;
        border-radius: 8px 8px 8px 0px;
        font-size: 10px;
        font-weight: bold;
        color: #FFFFFF;
        line-height: 16px;
        text-align: center;
        margin-bottom: 4px;
      }
    }
  }
}
</style>